package one.healthium.domain.user.migration

import kotlinx.coroutines.sync.Mutex
import kotlinx.coroutines.sync.withLock
import one.healthium.base.preferences.AppPreferences
import one.healthium.domain.user.UserModel

class UserMigrationManager(
    private val appPreferences: AppPreferences
) {
    private val mutex = Mutex()

    suspend fun tryMigrate(user: UserModel) {
        mutex.withLock {
            migrateNativeIosUser(user)
        }
    }

    private suspend fun migrateNativeIosUser(user: UserModel) {
    }
}